import ScalarIconArrowRight_vue_vue_type_script_setup_true_lang_default from "./ScalarIconArrowRight.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconArrowRight.vue
var ScalarIconArrowRight_default = ScalarIconArrowRight_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconArrowRight_default as default };

//# sourceMappingURL=ScalarIconArrowRight.js.map